export const footerServices = [
  ['asphalt-milling', 'Asphalt Milling', '/services/asphalt-milling/'],
  ['full-depth-milling', 'Full-Depth Milling', '/services/asphalt-milling/#full-depth-milling'],
  ['roadway-milling', 'Roadway Milling', '/services/road-milling/'],
  ['parking-lot-milling', 'Parking Lot Milling', '/services/parking-lot-milling/'],
  ['commercial-milling', 'Commercial Milling', '/services/parking-lot-milling/'],
  ['milling-hauling', 'Milling & Hauling', '/services/asphalt-milling/#material-handling'],
  ['all-services', 'All Services', '/services/'],
];
export const quickLinks = [
  ['home', 'Home', '/'], ['equipment', 'Equipment', '/equipment/'], ['projects', 'Projects', '/projects/'],
  ['about', 'About Longhorn Milling', '/about/'], ['careers', 'Careers', '/careers/'],
  ['quote', 'Request a Quote', '/request-a-quote/'], ['contact', 'Contact Us', '/contact/'],
];
export const workLinks = [
  ['become-subcontractor', 'Become a Subcontractor', '/subcontractors/'],
  ['subcontractor-login', 'Subcontractor Login', '/subcontractors/login/'],
  ['subcontractor-forms', 'Subcontractor Forms', '/subcontractors/forms/'],
  ['insurance', 'Insurance Requirements', '/subcontractors/insurance/'],
  ['careers', 'Careers', '/careers/'], ['vendor-resources', 'Vendor Resources', '/subcontractors/resources/'],
];
export const areaLinks = [
  ['fort-worth', 'Fort Worth', '/service-areas/fort-worth-tx/'], ['dallas', 'Dallas', '/service-areas/dallas-tx/'],
  ['arlington', 'Arlington', '/service-areas/arlington-tx/'], ['denton', 'Denton', '/service-areas/denton-tx/'],
  ['lewisville', 'Lewisville', null], ['mckinney', 'McKinney', '/service-areas/mckinney-tx/'],
  ['frisco', 'Frisco', '/service-areas/frisco-tx/'], ['plano', 'Plano', '/service-areas/plano-tx/'],
];
export const legalLinks = [['privacy', 'Privacy Policy', '/privacy-policy/'], ['terms', 'Terms of Use', '/terms-of-use/'], ['accessibility', 'Accessibility', '/accessibility/'], ['contact', 'Contact', '/contact/']];